/**
 * Le thème de l'espace élève, d'après la règle commune (`isDarkFor`).
 */
import { isDarkFor } from "./appearanceTheme"
import type { StudentAppearancePreference } from "./studentAppearancePreference"

/** Les deux thèmes élève enregistrés dans `design-system/unistyles.ts`. */
export type StudentThemeName = "student" | "studentDark"

export function studentThemeFor(
    systemScheme: "light" | "dark" | null | undefined,
    preference: StudentAppearancePreference
): StudentThemeName {
    return isDarkFor(systemScheme, preference) ? "studentDark" : "student"
}
